import React from 'react';

export default function Button({
  children,
  color = 'mint',
  size = 'sm',
  onClick,
  disabled = false,
  className = '',
  href,
  target,
  rel,
  ...props
}) {
  const baseClasses =
    'flex justify-center items-center gap-2 transition-all duration-200 font-semibold leading-none whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed';

  const colorClasses = {
    mint: 'bg-[#00A98B] text-white hover:bg-[#008A73] active:bg-[#007A65]',
    glass:
      'bg-white/16 text-white backdrop-blur-xs border border-white/16 hover:bg-white/20 active:bg-white/24',
    gray: 'bg-white/8 text-white hover:bg-white/12',
    outline:
      'border border-white/16 bg-transparent text-white hover:bg-white/8',
    yellow: 'bg-yellow text-black hover:bg-[#D4C865]',
    outlineGray:
      'border border-white/16 bg-white/16 text-white hover:bg-white/8',
    white: 'bg-white text-black hover:bg-white/80',
  };

  const sizeClasses = {
    xs: 'p-2 rounded-lg text-13',
    sm: 'px-4 py-2 rounded-lg text-base md:text-13',
    md: 'px-6 py-[1.125rem] rounded-xl text-base',
    rounded: 'px-4 py-2 rounded-full text-base md:text-13',
    lg: 'px-14 py-[1.125rem] rounded-xl text-lg md:text-base',
  };

  const buttonClasses = `${baseClasses} ${colorClasses[color]} ${sizeClasses[size]} ${className}`;

  if (href) {
    return (
      <a
        href={href}
        target={target}
        rel={rel}
        className={buttonClasses}
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      type='button'
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}
